import VueUeditorWrap from './vue-ueditor-wrap.vue';
export default VueUeditorWrap;
